// extracted by mini-css-extract-plugin
export default {"option":"ProvisionSelectOption-module__option--W9Sdi","badge":"ProvisionSelectOption-module__badge--m33HG"};